import { render } from "./PopEdit.vue?vue&type=template&id=bcb1a82e&scoped=true"
import script from "./PopEdit.vue?vue&type=script&lang=js"
export * from "./PopEdit.vue?vue&type=script&lang=js"

import "./PopEdit.vue?vue&type=style&index=0&id=bcb1a82e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb1a82e"]])

export default __exports__